export const companyInfo = {
  name: "Grupo Onix",
  tagline: "Tecnología al alcance de tus manos",
  logo: "https://customer-assets.emergentagent.com/job_1e517cd0-6143-4cee-b214-d79dab6ca243/artifacts/v0wp4ujc_logo%20%283%29.png",
  phone: "+52 (555) 123-4567",
  email: "contacto@grupoonix.com",
  address: "Av. Tecnología 1250, Col. Innovación, CDMX, México",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    whatsapp: "#"
  }
};

export const stats = [
  { value: "500+", label: "Proyectos Completados" },
  { value: "8+", label: "Años de Experiencia" },
  { value: "200+", label: "Clientes Satisfechos" },
  { value: "24/7", label: "Soporte Técnico" }
];

export const services = [
  {
    id: "redes",
    title: "Redes y Cableado Estructurado",
    shortDesc: "Diseño e instalación de redes de datos y fibra óptica para empresas y hogares.",
    description: "Ofrecemos soluciones integrales en redes de datos, cableado estructurado y fibra óptica. Desde el diseño hasta la implementación, garantizamos conectividad de alta velocidad y confiabilidad para tu negocio u hogar.",
    features: [
      "Cableado estructurado Cat 5e, Cat 6 y Cat 6A",
      "Instalación de fibra óptica",
      "Configuración de routers y switches",
      "Redes WiFi empresariales",
      "Diagnóstico y mantenimiento de redes",
      "Rack y organización de cableado"
    ],
    image: "https://images.unsplash.com/photo-1597733336794-12d05021d510?w=800&auto=format",
    icon: "Network"
  },
  {
    id: "cctv",
    title: "CCTV y Videovigilancia",
    shortDesc: "Sistemas de seguridad con cámaras de alta definición y monitoreo remoto.",
    description: "Protege tu patrimonio con nuestros sistemas de videovigilancia de última generación. Instalamos cámaras de alta definición con visión nocturna, detección de movimiento y acceso remoto desde tu celular.",
    features: [
      "Cámaras HD y 4K",
      "Visión nocturna infrarroja",
      "Monitoreo remoto 24/7",
      "Grabación en la nube y local",
      "Detección inteligente de movimiento",
      "Instalación interior y exterior"
    ],
    image: "https://images.unsplash.com/photo-1566060475410-1159300f046f?w=800&auto=format",
    icon: "Camera"
  },
  {
    id: "solar",
    title: "Paneles Solares",
    shortDesc: "Energía limpia y ahorro económico con sistemas fotovoltaicos profesionales.",
    description: "Transforma la energía del sol en ahorro para tu hogar o negocio. Diseñamos e instalamos sistemas fotovoltaicos que reducen tu factura eléctrica hasta un 95%, con garantía de rendimiento y mantenimiento incluido.",
    features: [
      "Paneles de alta eficiencia",
      "Inversores de última generación",
      "Sistemas conectados a la red (On-Grid)",
      "Sistemas autónomos (Off-Grid)",
      "Monitoreo de producción en tiempo real",
      "Garantía de 25 años en paneles"
    ],
    image: "https://images.pexels.com/photos/8853499/pexels-photo-8853499.jpeg?w=800&auto=compress",
    icon: "Sun"
  }
];

export const aboutData = {
  mission: "Brindar soluciones tecnológicas de vanguardia en redes, seguridad y energía solar, con un compromiso inquebrantable de calidad, innovación y servicio al cliente.",
  vision: "Ser la empresa líder en soluciones tecnológicas integrales en México, reconocida por nuestra excelencia técnica y la confianza de nuestros clientes.",
  values: [
    { title: "Innovación", desc: "Adoptamos las últimas tecnologías para ofrecer las mejores soluciones." },
    { title: "Calidad", desc: "Cada proyecto se ejecuta con los más altos estándares de calidad." },
    { title: "Compromiso", desc: "Nos dedicamos al 100% a la satisfacción de nuestros clientes." },
    { title: "Integridad", desc: "Trabajamos con transparencia y honestidad en cada proyecto." }
  ],
  history: "Fundada en 2017, Grupo Onix nació con la visión de democratizar el acceso a la tecnología. Lo que comenzó como un pequeño equipo de técnicos apasionados, se ha convertido en una empresa integral que ofrece soluciones en redes, seguridad electrónica y energía solar. Hoy, con más de 500 proyectos completados, seguimos creciendo y evolucionando para llevar la tecnología al alcance de tus manos."
};

export const testimonials = [
  {
    name: "Carlos Mendoza",
    role: "Director, TechCorp MX",
    text: "Grupo Onix transformó nuestra infraestructura de red. La velocidad y confiabilidad mejoraron un 300%. Excelente servicio profesional.",
    rating: 5
  },
  {
    name: "María García",
    role: "Gerente, Restaurante El Sol",
    text: "El sistema de CCTV que instalaron nos da total tranquilidad. Podemos monitorear todo desde el celular. Muy recomendados.",
    rating: 5
  },
  {
    name: "Roberto Hernández",
    role: "Propietario, Casa Residencial",
    text: "Los paneles solares redujeron mi recibo de luz en un 90%. La inversión se pagó sola en menos de 3 años. Increíble.",
    rating: 5
  }
];

export const contactReasons = [
  "Cotización de Redes",
  "Cotización de CCTV",
  "Cotización de Paneles Solares",
  "Soporte Técnico",
  "Otro"
];
